export default __webpack_public_path__ + "static/media/LOGO-RED-MONEY.4b7ba34d.png";